import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordSimilarContributorsStatistic } from '../../../../services/statistics-service';

const Img = styled.img`
  border: 1.4px solid white;
  border-radius: ${props => (props.type === 'circle' ? 40 : 4)}px;
  filter: drop-shadow(0px 2.74px 5.47px rgba(50, 50, 71, 0.2));
  width: ${props => (props.type === 'list' ? 40 : 52)}px;
  height: ${props => (props.type === 'list' ? 40 : 52)}px;
  margin: 0;
`;

const dataTooltip = id => ({
  'data-tip': true,
  'data-for': `Contributor-${id}`,
});

export default function Avatar({
  id, publicUrl, name, profilePictureUrl, type, clickable, hoverable,
}) {
  const imgProps = {
    type,
    src: profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png'),
    alt: name,
    ...(hoverable ? dataTooltip(id) : {}),
  };

  if (!clickable) {
    return <Img {...imgProps} />;
  }

  const collectStats = () => {
    recordSimilarContributorsStatistic(id);
  };

  return (
    <a href={publicUrl} onClick={collectStats}>
      <Img {...imgProps} />
    </a>
  );
}

Avatar.propTypes = {
  id: PropTypes.number.isRequired,
  publicUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
  clickable: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['list', 'square', 'circle']).isRequired,
  hoverable: PropTypes.bool,
};

Avatar.defaultProps = {
  profilePictureUrl: null,
  hoverable: false,
};
